import { boolean, z } from 'zod';

export const booleanParamSchema = z
  .enum(['true', 'false'])
  .transform((value) => value === 'true');

export const successSchema = z.object({
  success: boolean(),
});
